<app-upsell-card
  htmlTitle="<strong>Important: Maximize</strong> Your GLP-1 Results"
  question="Would you like to add the GLP-1 Booster to your treatment plan?"
  [slug]="slug"
  [options]="options"
  (continueButtonPressed)="onContinueButtonPressed($event)"
>
  <p class="mb-4">
    The <strong>GLP-1 Booster</strong> is a science-backed, all-natural supplement designed to
    <strong>work hand-in-hand with your GLP-1 treatment for faster, more effective weight loss</strong>. It's extremely
    beneficial for enhancing results and supporting digestive health during your journey.
  </p>
  <p>Each capsule helps by:</p>
  <ul class="mb-4">
    <li>Slowing gastric emptying</li>
    <li>Reducing appetite and cravings</li>
    <li>Promoting healthy digestion</li>
    <li>Supporting steady blood sugar levels</li>
  </ul>
  <p class="mb-4">
    The GLP-1 Booster includes a <strong>30-day supply (60 capsules)</strong> and is shelf-stable for convenient daily
    use.
  </p>
</app-upsell-card>
